/**
 * Returns `p` if it is a string starting with `/`, otherwise `null`.
 * Prevents open-redirect attacks when restoring the last visited path.
 */
export const safeInternalPath = (p: unknown) => {
	return typeof p === 'string' && p.startsWith('/') ? p : null
}
